import { useEffect } from 'react'
import { NewList } from './components'
import { CareUserListContainer } from './styles'
import { useLayoutContext } from '@sr/routes/common'
import { useTranslation } from 'react-i18next'

export const DownloadFiles = () => {
  const { t } = useTranslation()
  const { setBackButtonText } = useLayoutContext()

  useEffect(() => {
    setBackButtonText(t('dashboard.downloadFiles.title'))
  }, [])

  return (
    <CareUserListContainer>
      <NewList />
    </CareUserListContainer>
  )
}
